
// Pages Component
import Chat from "../pages/Chat/Chat"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Page-login"
import Register1 from "../pages/AuthenticationInner/page-register"
import Recoverpw from "../pages/AuthenticationInner/page-recoverpw"
import LockScreen from "../pages/AuthenticationInner/page-lock-screen"
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail"
import EmailVerification from "../pages/AuthenticationInner/page-email-verification"
import TwostepVerification from "../pages/AuthenticationInner/page-two-step-verification"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Charts
import ChartApex from "../pages/Charts/Apexcharts"

// Maps
import Maps from "../pages/Maps/Maps"

//Icons
import IconBoxicons from "../pages/Icons/Boxicons"
import IconDripicons from "../pages/Icons/Dripicons"
import IconMaterialdesign from "../pages/Icons/Materialdesign"
import IconFontawesome from "../pages/Icons/Fontawesome"

//Tables
import BasicTables from "../pages/Tables/BasicTables"
import DatatableTables from "../pages/Tables/DatatableTables"

// Forms
import FormElements from "../pages/Forms/FormElement"
import FormAdvanced from "../pages/Forms/FormAdvanced"

//Ui
import UiElements from '../pages/UiElemets/UiElemets'

//Pages
import PagesStarter from "../pages/Utility/pages-starter"
import Preloader from '../pages/Utility/Preloader';
import Profile from "../pages/Utility/Profile/Profile";
import Invoice from "../pages/Utility/Invoice";
import Maintenance from "../pages/Utility/Maintenance"
import PagesComingsoon from "../pages/Utility/Comingsoon"
import Timeline from "../pages/Utility/TimeLine"
import Pricing from "../pages/Utility/Pricing"
import Error404 from "../pages/Utility/Error404"
import Error500 from "../pages/Utility/Error500"

//Adanace kit
import SweetAlert from '../pages/AdvanaceKit/SweetAlert';
import RangeSlider from "../pages/AdvanaceKit/RangeSlider"
import Notification from "../pages/AdvanaceKit/Notifications";
import Carousel from "../pages/AdvanaceKit/Carousel";
import Typography from "../pages/Typography";
import DataTableTeste from "../pages/DataTableTeste/DataTableTeste"
import UserList from "../pages/User/UserList"
import UserDetail from "../pages/User/UserDetail"
import BusinessList from "../pages/Business/BusinessList"
import BusinessDetail from "../pages/Business/BusinessDetail"
import RegionList from "../pages/Regions/RegionList"
import RegionDetail from "../pages/Regions/RegionDetail"
import LogoList from "../pages/Logo/LogoList"
import LogoDetail from "../pages/Logo/LogoDetail"
import MonacoEditorTeste from "../pages/MonacoEditorTeste/MonacoEditorTeste"
import TinyEditorTeste from "../pages/TinyEditorTeste/TinyEditorTeste"
import TableStyleList from "../pages/Styles/TableStyleList"
import ListStyleList from "../pages/Styles/ListStyleList"
import TextStyleList from "../pages/Styles/TextStyleList"
import TemplateList from "../pages/Templates/TemplateList"
import TemplateDetail from "../pages/Templates/TemplateDetail"
import TableStyleDetail from "../pages/Styles/TableStyleDetail"
import ListStyleDetail from "../pages/Styles/ListStyleDetail"
import TextStyleDetail from "../pages/Styles/TextStyleDetail"
import DocumentBuiderTeste from "../pages/DocumentBuiderTeste/DocumentBuiderTeste"
import SectionList from "../pages/Sections/SectionList"
import SectionDetail from "../pages/Sections/SectionDetail"
import SnippetList from "../pages/Snippets/SnippetList"
import SnippetDetail from "../pages/Snippets/SnippetDetail"
import DocumentCenter from "../pages/DocumentCenter/DocumentCenter"
import DocumentList from "../pages/Documents/DocumentList"
import DocumentDetail from "../pages/Documents/DocumentDetail"
import BulkMain from "../pages/Bulk/BulkMain"


const userRoutes = [
  { path: "/dashboard", component: Dashboard, isAuthProtected: false },

  //chat
  { path: "/chat", component: Chat },

  // //calendar
  { path: "/calendar", component: Calendar },

  // //profile
  { path: "/profile", component: UserProfile },

  //Email
  { path: "/email-inbox", component: EmailInbox },
  { path: "/email-read", component: EmailRead },

  //Charts
  { path: "/charts", component: ChartApex },

  // Icons
  { path: "/icons-boxicons", component: IconBoxicons },
  { path: "/icons-dripicons", component: IconDripicons },
  { path: "/icons-materialdesign", component: IconMaterialdesign },
  { path: "/icons-fontawesome", component: IconFontawesome },

  // Tables
  { path: "/tables-basic", component: BasicTables },
  { path: "/tables-datatable", component: DatatableTables },

  // Maps
  { path: "/maps", component: Maps },

  // Forms
  { path: "/form-elements", component: FormElements },
  { path: "/form-advanced", component: FormAdvanced },

  // Ui
  { path: '/ui-components', component: UiElements },

  //Advanace kit
  { path: "/advanced-sweet-alert", component: SweetAlert },
  { path: "/advanced-rangeslider", component: RangeSlider },
  { path: "/advanced-notifications", component: Notification },
  { path: "/advanced-carousel", component: Carousel },
  { path: "/typography", component: Typography },

  //Utility
  { path: "/pages-starter", component: PagesStarter },
  { path: "/pages-preloader", component: Preloader },
  { path: "/pages-profile", component: Profile },
  { path: "/pages-invoice", component: Invoice },
  { path: "/pages-timeline", component: Timeline },
  { path: "/pages-pricing", component: Pricing },
  { path: "/logout", component: Logout, isAuthProtected: false },

  { path: "/teste-datatable", component: DataTableTeste, isAuthProtected: true },
  { path: "/teste-tiny-editor", component: TinyEditorTeste, isAuthProtected: true },
  { path: "/teste-monaco-editor", component: MonacoEditorTeste, isAuthProtected: true },
  { path: "/teste-document-buider", component: DocumentBuiderTeste, isAuthProtected: true },

  { path: "/users", component: UserList, isAuthProtected: true },
  { path: "/user", component: UserDetail, isAuthProtected: true },

  { path: "/regions", component: RegionList, isAuthProtected: true},
  { path: "/region", component: RegionDetail, isAuthProtected: true},

  { path: "/businesses", component: BusinessList, isAuthProtected: true },
  { path: "/business", component: BusinessDetail, isAuthProtected: true },

  { path: "/logos", component: LogoList, isAuthProtected: true },
  { path: "/logo", component: LogoDetail, isAuthProtected: true },

  { path: "/table-styles", component: TableStyleList, isAuthProtected: true },
  { path: "/list-styles", component: ListStyleList, isAuthProtected: true },
  { path: "/text-styles", component: TextStyleList, isAuthProtected: true },
  { path: "/table-style", component: TableStyleDetail, isAuthProtected: true },
  { path: "/list-style", component: ListStyleDetail, isAuthProtected: true },
  { path: "/text-style", component: TextStyleDetail, isAuthProtected: true },

  { path: "/templates", component: TemplateList, isAuthProtected: true },
  { path: "/template", component: TemplateDetail, isAuthProtected: true },

  { path: "/sections", component: SectionList, isAuthProtected: true },
  { path: "/section", component: SectionDetail, isAuthProtected: true },

  { path: "/snippets", component: SnippetList, isAuthProtected: true },
  { path: "/snippet", component: SnippetDetail, isAuthProtected: true },

  { path: "/documents", component: DocumentList, isAuthProtected: true },
  { path: "/document", component: DocumentDetail, isAuthProtected: true },
  
  { path: "/bulk-actions", component: BulkMain, isAuthProtected: true },

  { path: "/document-center", component: DocumentCenter, isAuthProtected: false },

  // this route should be at the end of all other routes
  { path: "/", component: Dashboard, isAuthProtected: false },
]

const authRoutes = [
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },

  { path: "/pages-maintenance", component: Maintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Error404 },
  { path: "/pages-500", component: Error500 },

  //   // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/pages-register", component: Register1 },
  { path: "/pages-recoverpw", component: Recoverpw },
  { path: "/pages-lock-screen", component: LockScreen },
  { path: "/pages-confirm-mail", component: ConfirmMail },
  { path: "/pages-email-verification", component: EmailVerification },
  { path: "/pages-two-step-verification", component: TwostepVerification },
]

export { userRoutes, authRoutes }
